<template>
  <div>
    <a-input :placeholder="placeholder" v-model.trim="showLabel" readonly @click="showModal">
      <slot name="prefix" slot="prefix" />
      <slot name="suffix" slot="suffix">
        <a-icon :type="icon" />
      </slot>
    </a-input>

    <a-modal
      :width="modalWidth"
      :title="modalTitle"
      v-model.trim="visible"
      @ok="pick"
      :okText="$t('confirm')"
      :cancelText="$t('cancel')"
    >
      <dol-list
        :card-flag="false"
        :url="url"
        :method="method"
        :query-data="queryData"
        :query-params="queryParams"
        :query-path-data="queryPathData"
        :columns="columns"
        :selected-row-keys.sync="selectedRowKeys"
        :selection-type="selectionType"
        :row-key="valueField"
        ref="list">
        <slot name="queryForm" slot="queryForm" />
        <slot name="listFormatter" />
      </dol-list>
    </a-modal>
  </div>
</template>

<script>
  export default {
    name: "dol-select-modal",
    props:{
      value: {},
      icon: {type: String, default: 'ellipsis'},
      placeholder: {type: String, default: '--请选择--'},
      modalWidth: {type: String, default: '1000px'},
      modalTitle: {type: String, default: '请选择'},
      url: {type: String},
      method: {type: String, default: 'post'},              //请求方式
      queryData:{type: Object, default: () => {}},          //请求参数
      queryParams:{type: Object, default: () => {}},        //请求参数
      queryPathData:{type: Object, default: () => {}},      //请求参数
      multiple:{type: Boolean, default: false},      //请求参数
      columns: {type: Array, default: () => {return [
        { dataIndex: 'name', title: '名称' },
        { dataIndex: 'code', title: '编码' },
      ]}},
      labelField: {type: String, default: 'name'},               //label
      valueField: {type: String, default: '_id'},               //value
    },
    data(){
      return {
        visible: false,
        queryForm: {},
        selectedRowKeys: [],
      }
    },
    computed:{
      showLabel(){
        let label;
        if(this.multiple){
          let labelArray = [];
          if(this.value){
            this.value.forEach(v => {
              labelArray.push(v[this.labelField]);
            });
          }
          label = labelArray.join('、');
        }else{
          if(this.value){
            label = this.value[this.labelField];
          }else{
            label = '';
          }
        }

        return label;
      },
      selectionType(){
        if(this.multiple){
          return 'checkbox';
        }else{
          return 'radio';
        }
      },
    },
    methods:{
      showModal(){
        this.init();
        this.visible = true;
      },
      init(){
        let rowKeys = [];
        if(this.multiple){
          if(this.value){
            this.value.forEach(v => {
              rowKeys.push(v[this.valueField]);
            })
          }
        }else{
          if(this.value){
            rowKeys.push(this.value[this.valueField]);
          }
        }
        this.selectedRowKeys = rowKeys;
      },
      pick(){
        let value;
        if(this.multiple){
          value = [];
          this.selectedRowKeys.forEach(rowKey => {
            value.push(this.$refs.list.tableData.find(d => d[this.valueField] === rowKey));
          });
        }else{
          this.selectedRowKeys.forEach(rowKey => {
            value = this.$refs.list.tableData.find(d => d[this.valueField] === rowKey);
          });
        }

        this.$emit('input', value);
        this.visible = false;
      },
      query(){
        this.$refs.list.query();
      },
    },
    created() {
    }
  }
</script>

<style lang="scss" scoped>

</style>
